import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'
import { ExpensesExpensableGroupFilter } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

type Props = BaseFilterProps & {
  visible?: boolean
}

const ownerFilter = ({
  expensesContext,
  initialFilterValues,
  visible = false,
}: Props): DataTableFilter<ExpensesExpensableFilter | ExpensesExpensableGroupFilter> => {
  return {
    type: FilterType.Entity,
    categories: [
      {
        kind: 'Employee',
        operation: 'in',
        value: initialFilterValues.employees,
      },
    ],
    onUpdateValue: () => {
      trackFilters('employee', expensesContext)
    },
    identifier: 'expensesList.employeeFilter',
    path: 'owner',
    title: i18n.t('expenses_v2.list.filters.label_owner'),
    default: visible || !!initialFilterValues.employees,
  }
}

export default ownerFilter
